import SimpleReactValidator from "simple-react-validator"

export const validatorFactory = function (options = {}) {
  return new SimpleReactValidator({
    className: "text-danger",
    ...options,
    validators: {
      maxHeight: {
        message:
          "This marina supports a maximum clearance of :heightConstraint feet.",
        messageReplace: (message, params) =>
          message.replace(":heightConstraint", params[0]),
        rule: (val, params, validator) => {
          return (
            parseFloat(val) <= parseFloat(params[0]) && parseFloat(val) >= 1
          )
        },
      },
      maxDraft: {
        message:
          "This marina supports a maximum draft of :depthConstraint feet.",
        messageReplace: (message, params) =>
          message.replace(":depthConstraint", params[0]),
        rule: (val, params, validator) => {
          return (
            parseFloat(val) <= parseFloat(params[0]) && parseFloat(val) >= 1
          )
        },
      },
      maxDecimalPrecision: {
        message: "The maximum precision is :price decimals.",
        messageReplace: (message, params) =>
          message.replace(":price", params[0]),
        rule: (val, params, validator) => {
          return (
            !val ||
            (val.toString().split(".")[1] &&
              val.toString().split(".")[1].length <= parseInt(params[0]))
          )
        },
      },
      ...options.validators,
    },
  })
}
